<!--
 * @Author: yn
 * @Date: 2026-09-10 11:01:35
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-10 18:25:00
 * @Description: 编辑结束时间
-->

<script>
import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      buttonText: {
        submit: '确定',
        close: '取消',
      },
    };
  },
  async mounted() {
    await this.getFormRule('edit_end_time_form');
  },
  methods: {
    // 设置表单规则：统一结束时间格式
    setRule(item) {
      const v = item;
      const row = (this.formConfig && this.formConfig.row) || {};
      // 修改结束时间
      if (v.field === 'activityEndTime') {
        v.props = {
          ...v.props,
          type: 'datetime',
          defaultTime: '23:59:59',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        };
      }
      // 当前结束时间：仅展示列表行数据中的 activityEndTime
      if (v.field === 'activityEndTimeOld') {
        v.value = row.activityEndTime;
        v.props = {
          ...v.props,
          disabled: true,
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        };
      }
      return v;
    },
    // 校验结束时间必须严格晚于次日 00:00:00
    checkEndTime(endTime) {
      if (!endTime) {
        this.$message.error('请选择结束时间');
        return false;
      }
      // 次日 00:00:00
      const tomorrow = new Date();
      tomorrow.setHours(0, 0, 0, 0);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const end = new Date(String(endTime).replace(/-/g, '/'));
      if (Number.isNaN(end.getTime()) || end.getTime() <= tomorrow.getTime()) {
        this.$message.error('结束时间必须晚于次日 00:00:00');
        return false;
      }
      return true;
    },
    // 提交
    submit() {
      const formData = this.getFormData();
      if (!formData) return false;
      const { activityEndTime } = formData;
      if (!this.checkEndTime(activityEndTime)) return false;
      const params = {
        id: this.formConfig.row && this.formConfig.row.id,
        activityEndTime,
      };
      request.post('/cps-mobile/consumerscanactivitymain/updateEndTime', params).then((res) => {
        if (res.success) {
          this.$message.success('操作成功');
          this.$emit('onClose');
          this.$emit('onGetList');
        }
      });
      return true;
    },
  },
};
</script>
